import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Carousel } from 'antd';
import './index.less';
import ComponentLog from '@/components/component-log';

function BaseSwiper(props, ref) {
  const carousel = useRef();
  const [currentPage, setCurrentPage] = useState(0);
  const [swiperLeft, setSwiperLeft] = useState('swiper-left');
  const [swiperRight, setSwiperRight] = useState('swiper-right');
  const [isHover, setIsHover] = useState(false);
  const arr = [];

  useImperativeHandle(ref, () => ({
    pageJump: (index) => pageJump(index),
  }));

  useEffect(() => {
    if (currentPage === 0) {
      setSwiperLeft('swiper-left swiper-final');
    } else {
      setSwiperLeft('swiper-left');
    }
    if (currentPage === props.len - 1) {
      setSwiperRight('swiper-right swiper-final');
    } else {
      setSwiperRight('swiper-right');
    }
  }, [currentPage, props.len]);

  if (!props.children) return null;

  // 生成点
  for (let i = 0; i < props.len; i++) {
    arr.push(i);
  }

  function isCurrent(value) {
    return currentPage === value ? 'dot-select' : 'dot-circle';
  }

  function pageJump(index) {
    carousel.current.goTo(index, false);
    setCurrentPage(index);
  }

  function jumpPrev() {
    if (currentPage !== 0) {
      pageJump(currentPage - 1);
    }
  }

  function jumpNext() {
    if (currentPage < props.len - 1) {
      pageJump(currentPage + 1);
    }
  }

  return (
    <div
      className="swiper-wrapper"
      style={{ height: props.height }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {arr.length > 1 && (
        <div className="dot-container">
          {arr.map((item, index) => (
            <ComponentLog key={index}>
              <div
                clstag={props.cls}
                className={isCurrent(index)}
                onClick={() => {
                  pageJump(index);
                }}
              />
            </ComponentLog>
          ))}
        </div>
      )}

      {props.isJump && isHover && (
        <>
          <ComponentLog>
            <div clstag={props.cls} className={swiperLeft} onClick={jumpPrev}>
              <LeftOutlined />
            </div>
          </ComponentLog>
          <ComponentLog>
            <div clstag={props.cls} className={swiperRight} onClick={jumpNext}>
              <RightOutlined />
            </div>
          </ComponentLog>
        </>
      )}
      <Carousel ref={carousel} dots={false}>
        {props.children}
      </Carousel>
    </div>
  );
}

export default React.forwardRef(BaseSwiper);
